import React from 'react';
import Slider from 'rc-slider';
import styles from './trim-video-progress.module.scss';
import './trim-video-progress.scss';

export interface TrimVideoProgressProps {
  duration: number;
  current: number;
  source?: string;
}

const sliderClassName = `trimVideoProgress`;

export function TrimVideoProgress({...props}: TrimVideoProgressProps) {
  return <Slider className={`${sliderClassName}`} step={0.0001} min={0} max={props.duration} value={props.current} />;
}
